import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
 
}

export class MultiTextComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

   let field = this.props.field;
   FormValidationUtils.runJavascript(field);
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }

  onTextEditChange = (e) => {
    let field =  this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    field.Value = val;
 
    FormValidationUtils.validateText(field);

    FormValidationUtils.runJavascript(field);
   
    this.props.callbackElement(this.props.field.parent.parent.parent);
  }

  render() {
    let field = this.props.field;
    let displayfield: boolean = true;
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    let isCounterDisplay = field.counterVisible;

    isCounterDisplay = field.counterVisible;

    let lengthAndRow = field.Length;
    let numOfRow = 3;
    let maxLength = 500;
    if (this.props.field.FilterField != null) {
      let filterValue;
      let baseName;
      let bindName;
      let parts = this.props.field.FilterField.split('.');
      if (parts.length == 3) {
        baseName = parts[0] + '.' + parts[1];
        bindName = parts[2];
      }
      if (parts.length == 2) {
        baseName = parts[0];
        bindName = parts[1];
      }
      if (parts.length == 1) {
        baseName = '';
        bindName = parts[0];
      }
      let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);
      let foundFilterField
      if (foundFilterFields != null && foundFilterFields.length > 0) {
        foundFilterField = foundFilterFields.at(0);
      }
      if (foundFilterField != null) {
        filterValue = foundFilterField.Value;

        if ((foundFilterField != null && (filterValue == null || filterValue == '')) || filterValue != null && (this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1)) {
          displayfield = false;
        }
      } else {
        displayfield = true;
      }
    }
    if (displayfield) {
      if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
        let arr = lengthAndRow.split(",");
        numOfRow = parseInt(arr[0].toString(), 10);
        maxLength = parseInt(arr[1].toString(), 10);
      } else if (lengthAndRow) {
        maxLength = parseInt(lengthAndRow);
      }

      if (editable) {
        if (field.Value == null)
          field.Value = '';

        controlArray.push(
          <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}     className="ontario-form-group" >
      
            {/* <label className="ontario-label" htmlFor="text-area-example"> */}
              {labelControlArray}
            {/* </label> */}

            <LiveValidationErrMsg
                             field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" +this.props.field.LoadBindName} />


            <textarea
              className="ontario-input"
              name="text-area-example"
              id={`input_${field.LoadBindName}_${field.Sequence}`}
              maxLength={maxLength}
              key={'fdIpt_textarea_' + field.Id}
              required={requiredField}
              value={field.Value}
              rows={numOfRow}
              readOnly={!editable}
              onChange={this.onTextEditChange}
              placeholder={field.enuToolTip}
            ></textarea>
            <div style={{ display: isCounterDisplay ? 'block' : 'none' }} className="word-count">{isCounterDisplay ? this.valueLength(field.Value) + "/" + maxLength : <br />}</div>
          </div>
        );
      } else {
        if (field.EGMSStyle == 'Row') {
          controlArray.push(
            <div>
              <div>{title}</div>
              <div style={{ whiteSpace: 'pre-line' }}>{field.Value}</div>
            </div>)
        } else {
          controlArray.push(
            <div className='pdf-two-column'>
              <div>{title}</div>
              <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{field.Value}</div>
            </div>
          );
        }
      }
    }

    return controlArray;
  }
}